module.exports = __webpack_public_path__ + "static/media/4.acef9c6d.jpeg";